module.exports = __webpack_public_path__ + "img/m2.3354367d.png";